import { render, staticRenderFns } from "./CargaDados.vue?vue&type=template&id=0d7ae00c"
import script from "./CargaDados.vue?vue&type=script&lang=js"
export * from "./CargaDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports